

import apiClient from 'api/apiClient';
import { getAuthenticatedSession } from 'cognito/auth';

export async function getFunds ( authenticatedUser )
{
    let authenticatedSession = null;
    
    try
    {
        authenticatedSession = await getAuthenticatedSession ();
    }
    catch ( error )
    {
        throw error;
    }

    return apiClient.get ( authenticatedUser.username + "/funds",
                { 
                    headers: { 
                        "authorization": authenticatedSession.idToken, 
                        "x-user-email": authenticatedUser.signInDetails.loginId,
                        "Content-Type": "application/json" } 
                } );
}

export async function putFunds ( authenticatedUser, value )
{
    let authenticatedSession = null;
    
    try
    {
        authenticatedSession = await getAuthenticatedSession ();
    }
    catch ( error )
    {
        console.err ( error );
        throw error;
    }

    let payload = {
        value: value
    };

    return apiClient.put ( authenticatedUser.username + "/funds", 
                payload,
                { 
                    headers: { 
                        "authorization": authenticatedSession.idToken, 
                        "x-user-email": authenticatedUser.signInDetails.loginId,
                        "Content-Type": "application/json" } 
                } );
}


export async function addEmails ( authenticatedUser, emails )
{
    let authenticatedSession = null;
    
    try
    {
        authenticatedSession = await getAuthenticatedSession ();
    }
    catch ( error )
    {
        throw error;
    }

    return apiClient.post ( authenticatedUser.username + "/participants", 
                emails,
                { 
                    headers: { 
                        "authorization": authenticatedSession.idToken, 
                        "x-user-email": authenticatedUser.signInDetails.loginId,
                        "Content-Type": "application/json" } 
                } );
}

export async function checkEmail ( authenticatedUser, email )
{
    let authenticatedSession = null;
    
    try
    {
        authenticatedSession = await getAuthenticatedSession ();
    }
    catch ( error )
    {
        throw error;
    }

    return apiClient.get ( authenticatedUser.username + "/participants/" + email,
                { 
                    headers: { 
                        "authorization": authenticatedSession.idToken, 
                        "x-user-email": authenticatedUser.signInDetails.loginId,
                        "Content-Type": "application/json" } 
                } );
}